import React, { Component } from 'react'

import T from '../../../SPRINTA/translate/T'

import { Text } from '../../atoms/Forms'
import Button from '../../atoms/Button'

import style from './style.css'

export default class SelectFileName extends Component {
    state = {
        file: null,
        name: ''
    }

    change(e) {
        this.setState({
            file: e.files[0],
            name: e.files[0].name
        }, () => {            
            this.props.file(this.state)
        })
    }

    changeName(name) {
        this.setState({
            name
        }, () => {
            this.props.file(this.state)            
        })
    }

    reset() {
        this.setState({
            name: '', 
            file: null
        })
    }

    render() {
        return (
            <div>
                <input className={style.file} ref='file' type='file' onChange={ (e) => this.change(e.target) } />
                <table className={style.table}>
                    <tbody>
                        <tr>
                            { this.state.file && (
                                <td>
                                    <div className={style.name}>
                                        <Text disabled='true' placeholder={T.txt('placeholder_name_file')} value={this.state.name} handleChange={(e) => this.changeName(e.target.value)} />
                                    </div>
                                </td>
                            )}
                            <td>
                                <Button type='button' disabled={this.props.disabled || false} onClick={() => {this.refs.file.click()}} color='orange-transparent'>{T.text('search')}</Button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/molecules/SelectFileName/index.js